import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { LogService } from '@pershing/pershing-core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MessagingConstants } from '../utils/messaging-constants';
import { PershingMessageDialog } from './pershing-message-dialog.component';

@Component({
    selector: 'pershing-message',
    templateUrl: 'pershing-message.component.html',
    entryComponents : [ PershingMessageDialog ]
})
export class PershingMessageComponent implements OnInit, OnChanges {
   @Input() displayType: string;
   @Input() messageType: string;
   @Input() message: any;
   // @Input() positiveActionConfig: any;
   // @Input() negativeActionConfig: any;
   @Input() buttonLabel: string;
   @Input() hideAfterInterval: string;
   @Input() width: string;
   @Output() notifyActionClicked: EventEmitter<any> = new EventEmitter();
   enableInpageMessage: boolean = false;
   modalDialogRef: MatDialogRef<PershingMessageDialog>;
   styleClasses: string[];
   modalWidth: string;

   constructor(private matDialog: MatDialog, private logService: LogService) {
   }

   ngOnInit() {
   }

   ngOnChanges(changes: SimpleChanges) {
       this.initMessage();
       this.logService.log('changes : ', changes);
   }

   initMessage() {
       if (this.message == null || this.messageType == null ) {
           this.logService.error('No input messageContent/messageType available');
       } else {
           if ((this.displayType).toLowerCase() === MessagingConstants.DISPLAYTYPE_INPAGE) {
               this.showInpageMessage();
           } else if ((this.displayType).toLowerCase() === MessagingConstants.DISPLAYTYPE_MODAL) {
               setTimeout(
                   () => {
                       this.showModalMessage();
                   }, 0);
           }
       }
   }

   showInpageMessage() {
       this.enableInpageMessage = true;
       if (this.hideAfterInterval && this.hideAfterInterval !== null ) {
           this.hideMessageAfterInterval(this.hideAfterInterval);
       }
   }

   showModalMessage() {
       console.log('showModalMessage');
       console.log(this.messageType);
       this.enableInpageMessage = false;
       if ( this.width && this.width != null) {
           this.modalWidth = this.width;
       } else {
           this.modalWidth = MessagingConstants.MODAL_WIDTH;
       }
       if ( this.buttonLabel && this.buttonLabel != null) {
           this.buttonLabel = this.buttonLabel;
       } else {
           this.buttonLabel = MessagingConstants.ACTION_BUTTON_LABEL;
       }
       this.modalDialogRef = this.matDialog.open(PershingMessageDialog, {
                   disableClose: true,
                   autoFocus: false,
                   id: 'modal-message-' + this.messageType,
                   width: this.modalWidth,
                   data: {
                           'messageContent': this.message,
                           'messageType': this.messageType,
                           'buttonLabel': this.buttonLabel
                           // 'positiveActionConfig': this.positiveActionConfig,
                           // 'negativeActionConfig': this.negativeActionConfig
                           }
                   });
       this.modalDialogRef.afterClosed().subscribe( result => {
           this.notifyActionClicked.emit(result);
           this.logService.log('result ', result);
       });

   }

   showMessage() {
       if (this.displayType) {
           if ((this.displayType).toLowerCase() === MessagingConstants.DISPLAYTYPE_INPAGE) {
               this.showInpageMessage();
           } else if ((this.displayType).toLowerCase() === MessagingConstants.DISPLAYTYPE_MODAL) {
               this.showModalMessage();
           }
       } else {
           this.logService.error('NxpMessageComponent - showMessage() : displayType not available');
       }
       // return this.getDialogReference();
   }

   hideMessageAfterInterval(timer: string) {
       setTimeout ( () => {
           this.enableInpageMessage = false;
       }, Number(timer)) ;
   }

   getDialogReference() {
       return this.modalDialogRef;
   }
}
